import EventManager from "../../store/sqftEventManager";
import CabinetShapes from "./cabinetShapes";
import store from "../../../../../../store";
import { setSQFTContextMenuV2 } from "../../../../../../actions/sqftMenuFunctions";
import workspace from "../workspace";
import { renderMeasurementsAroundSnappedShapes } from "../slab/sqftSlabDraw";
import CabinetShapesLayout from "./cabinetShapesLayout";
import { getMousePositionOnField } from "../../../../helpers/sqftHelper";
import {APPLIANCE_PART_IDS, CABINET_BOXES, SHAPE_PART_ID} from "../../../../constants";
import { getCurrentLayout } from "../../../../../appLayout";
import {createApplianceFromFeature} from "../../../../helpers/featureHelper";

class CabinetWorkspace {
  constructor() {
    this.eventManager = EventManager;
    this.objectName = { name: 'CabinetWorkspace' };
    this.state = {};
    this.cabinetShapes = new CabinetShapes();
    this.cabinetShapesLayout = new CabinetShapesLayout();
    this.measurementPoints = [];
    this.__crownMoldingParams = {
      distance: 10
    };
    this.isInited = false;

    // Store for pending cabinet creation
    this.pendingCabinetCreation = null;

    if (EventManager) {
      this.initCabinetEvents();
    }
  }

  initCabinetEvents() {
    this.deregisterEvents();

    EventManager.addEvent(EventManager.events.DROP, this.handleDrop, this.objectName, EventManager.priorities.OVERLAY);
    EventManager.addEvent(EventManager.events.DRAG_OVER, this.handleDrag, this.objectName, EventManager.priorities.OVERLAY);
    EventManager.addEvent(EventManager.events.RENDER, this.render, this.objectName, EventManager.priorities.OVERLAY);

    // Add mobile drop listener
    if (EventManager.canvas) {
      EventManager.canvas.addEventListener('mobileDrop', this.handleMobileDrop);
    }
  }

  render(ctx) {
    renderMeasurementsAroundSnappedShapes(ctx);
  }

  deregisterEvents() {
    EventManager.removeEvent(this.objectName);
    if (EventManager.canvas) {
      EventManager.canvas.removeEventListener('mobileDrop', this.handleMobileDrop);
    }
    this.isInited = false;
  }

  onRightClick(mousePos, e) {
    store.dispatch(setSQFTContextMenuV2({
      isOpened: true,
      title: workspace.intl.formatMessage({ id: "sqft.contextmenu.properties.title" }),
      menuItems: [
        {
          title: 'Change Cabinet Style',
          callback: new Function()
        },
        {
          title: 'Generate Countertop',
          callback: new Function()
        },
        {
          title: 'Generate Backsplash',
          callback: new Function()
        },
      ],
      position: { left: mousePos.x, top: mousePos.y }
    }));
    document.addEventListener('click', this.closeContextMenu);
    void e;
  }

  closeContextMenu(e) {
    const navClick = e.target.closest('[class*="contextmenu2"]');
    if (!navClick && !window.touchMove) {
      store.dispatch(setSQFTContextMenuV2({
        isOpened: false,
        title: '',
        menuItems: [],
        position: {}
      }));
    }
  }

  // Common method to create cabinet shape
  createCabinetShape(feature, parentFeature, partId, position) {
    if (!this.isValidCabinetPartId(partId)) {
      console.log('Invalid part ID:', partId);
      return;
    }

    if (!feature || !parentFeature) {
      console.error('Feature or parent feature not found');
      return;
    }

    const shapeId = this.cabinetShapes.addShape(feature, parentFeature, position);
    const shape = workspace.getShapeById(shapeId);

    if (shape && shape.shapeAutoShuffle) {
      shape.shapeAutoShuffle.handlePlaceShapeOnTheLine();
    }

    return shapeId;
  }

  // Helper to check valid cabinet part IDs
  isValidCabinetPartId(partId) {
    return [
      ...CABINET_BOXES,
      SHAPE_PART_ID.top_cabinet,
      SHAPE_PART_ID.bottom_cabinet,
      SHAPE_PART_ID.tall_cabinet,
      SHAPE_PART_ID.vanity_cabinet,
    ].includes(partId);
  }

  // Handle mobile drop event
  handleMobileDrop = (e) => {
    console.log('Mobile drop event received:', e.detail);

    const { featureId, parentFeatureId, partId, x, y } = e.detail;

    const layout = getCurrentLayout();
    const feature = layout.getFeatureById(featureId, true);
    const parentFeature = layout.getFeatureById(parentFeatureId, true);

    // Use the touch position for placement
    const position = getMousePositionOnField(x, y);
    console.log('Creating cabinet at position:', position);

    this.createCabinetShape(feature, parentFeature, partId, position);
  };

  handleDrop = (mousePos, e) => {
    e.preventDefault();

    debugger // eslint-disable-line no-debugger
    // 1. Retrieve raw data strings
    const dt = e.dataTransfer;
    const featureIdRaw     = dt.getData('featureId');
    const partIdRaw        = dt.getData('partId');
    const parentIdRaw      = dt.getData('parentFeatureId');

    if (!featureIdRaw || !partIdRaw) {
      console.log('Missing required drop data: featureId or partId');
      return;
    }

    // 2. Parse values
    let featureId, partId, parentFeatureId;
    try {
      featureId       = parseInt(featureIdRaw);
      parentFeatureId = parseInt(parentIdRaw);
      partId          = partIdRaw;
    } catch (err) {
      console.error('Error parsing drop data:', err);
      return;
    }

    // 3. Lookup feature and compute drop position
    const layout   = getCurrentLayout();
    const feature  = layout.getFeatureById(featureId, true);
    const position = getMousePositionOnField(mousePos.x, mousePos.y);

    // 4. Branch: appliance vs. cabinet
    if (APPLIANCE_PART_IDS.includes(partId)) {
      const appliance = createApplianceFromFeature(feature);
      appliance.setPosition(position);
    } else {
      if (!parentFeatureId) {
        console.log('parentFeatureId is required for cabinet shapes');
        return;
      }
      const parentFeature = layout.getFeatureById(parentFeatureId, true);
      this.createCabinetShape(feature, parentFeature, partId, position);
    }
  }

  handleDrag(mousePos, e) {
    e.preventDefault();

    // update hovered lines for rendering auto shuffle possibilities
    const hoveredLines = workspace.getHoveredLines();
    void hoveredLines;
  }
}

export default new CabinetWorkspace();
